module.exports = __webpack_public_path__ + "img/repeat.db30c40c.svg";